
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import DatePicker from "react-datepicker"
import { toast } from 'react-toastify';
import React, { useState } from 'react';
import Cookies from 'js-cookie';
import dayjs from 'dayjs';
import { addApplication, getJapaneseApplicationById, udpateApplication } from './keralaAdmissionSLice';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import MultiFieldModal from '../MultiFieldModal';
import LoadingSpinner from '../../../../component/resuable/LoadingSpinner';



export default function ApplicationForm({ handleBack, editData: engliahEditData, }) {
    const dispatch = useDispatch();
    const [newChip, setNewChip] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('EN')
    const japaneseApplication = useSelector((state) => state.keralaAdmission.japaneseApplication);
    const [isOpen, setIsModalOpen] = useState(false);
    const [initialModalData, setInitialModalData] = useState()
    const [activeModal, setActiveModal] = useState('');
    const editData = activeTab === "EN" ? engliahEditData : japaneseApplication?.candidates?.[0];

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("User Name is required"),
        sex: Yup.string().required("Sex is required"),
        file: Yup.string().required("File is required"),
        language: Yup.string().required("language is required"),
        employeer_name: Yup.string().required("Employeer Name is required"),
        phone: Yup.string().required("Phone Number is required"),
    });
    const validationSchemaJp = Yup.object().shape({
        name: Yup.string().required("ユーザー名は必須です"),
        sex: Yup.string().required("性別は必須です"),
        language: Yup.string().required("言語は必須です"),
        employeer_name: Yup.string().required("雇用者名は必須です"),
        japanese_language: Yup.string().required("日本語の言語は必須です"),
        phone: Yup.string().required("電話番号は必須です"),
    });

    const appendFileField = (formData, fieldName, value) => {
        if (value instanceof Blob || value instanceof File) {
            formData.append(fieldName, value);
        } else {
            formData.append(fieldName, '');
        }
    };

    let role = Cookies.get("role");
    const handleSubmit = async (values) => {
        const formattedArrivalDate = values.arrival_date ? dayjs(values.arrival_date).format('YYYY-MM-DD') : "";
        const formattedDob = values.dob ? dayjs(values.dob).format('YYYY-MM-DD') : "";
        setIsLoading(true);

        let formData = new FormData();
        formData.append('employeer_name', values.employeer_name);
        formData.append('name', values.name);
        formData.append('email', values.email);
        formData.append('phone', values.phone);
        formData.append('skill', values.skill.join(','));

        formData.append('sex', values.sex);
        formData.append('years_of_exp', values.years_of_exp);
        formData.append('language', values.language);

        formData.append('remarks', values.remarks);
        formData.append('employement_contract', values.employement_contract ? values.employement_contract.includes('http') ? '' : values.employement_contract : '');
        formData.append('emergency_contact', values.emergency_contact);
        // formData.append('contact_details', values.contact_details);
        formData.append('employeer_name', values.employeer_name);
        formData.append('arrival_date', formattedArrivalDate)

        //new fields
        formData.append('admission_number', values.admission_number);
        formData.append('ad_fees', values.ad_fees);
        formData.append('date_of_admission', '');
        // formData.append('date_of_admission', formattedDate_of_admission);
        formData.append('dob', formattedDob)
        formData.append('passport_no', values.passport_no);
        formData.append('height', values.height);
        formData.append('weight', values.weight);
        formData.append('marital_status', values.marital_status);
        formData.append('nationality', values.nationality);
        formData.append('religion', values.religion);
        formData.append('communication', values.communication);
        formData.append('reference', values.reference);
        formData.append('educational_qualification', values.educational_qualification);
        formData.append('additional_qualification', values.additional_qualification);
        formData.append('japanese_language', values.japanese_language || '');
        formData.append('english_knowledge', values.english_knowledge);
        appendFileField(formData, 'profile_pic', typeof values.profile_pic == "string" && values.profile_pic.includes('http') ? '' : values.profile_pic);
        appendFileField(formData, 'sign', typeof values.sign === 'string' && values.sign.includes('http') ? '' : values.sign);
        appendFileField(formData, 'file', typeof values.file === 'string' && values.file.includes('http') ? '' : values.file);
        appendFileField(formData, 'passport_copy', typeof values.passport_copy === 'string' && values.passport_copy.includes('http') ? '' : values.passport_copy);
        appendFileField(formData, 'resident_copy', typeof values.resident_copy === 'string' && values.resident_copy.includes('http') ? '' : values.resident_copy);
        appendFileField(formData, 'air_ticket', typeof values.air_ticket === 'string' && values.air_ticket.includes('http') ? '' : values.air_ticket);
        appendFileField(formData, 'coe', typeof values.coe === 'string' && values.coe.includes('http') ? '' : values.coe);
        appendFileField(formData, 'option_file', typeof values.option_file === 'string' && values.option_file.includes('http') ? '' : values.option_file);
        appendFileField(formData, 'visa', typeof values.visa === 'string' && values.visa.includes('http') ? '' : values.visa);
        appendFileField(formData, 'educationalCertificate', typeof values.educationalCertificate === 'string' && values.educationalCertificate.includes('http') ? '' : values.educationalCertificate);
        appendFileField(formData, 'medicalReport', typeof values.medicalReport === 'string' && values.medicalReport.includes('http') ? '' : values.medicalReport);
        appendFileField(formData, 'vaccinationCertificate', typeof values.vaccinationCertificate === 'string' && values.vaccinationCertificate.includes('http') ? '' : values.vaccinationCertificate);
        formData.append('age', values.age);
        formData.append('place_of_birth', values.place_of_birth);
        formData.append('reason_for_apply', values.reason_for_apply);
        formData.append('cooperative_living', values.cooperative_living);
        formData.append('favorite_subject', values.favorite_subject);
        formData.append('licenses_and_qualifications', values.licenses_and_qualifications);
        formData.append('tattoo', values.tattoo);
        formData.append('blood_type', values.blood_type);
        formData.append('right_vision', values.right_vision);
        formData.append('left_vision', values.left_vision);
        formData.append('color_blindness', values.color_blindness);
        formData.append('blood_pressure', values.blood_pressure);
        formData.append('dominant_hand', values.dominant_hand);
        formData.append('foods_cannot_eat', values.foods_cannot_eat.join(','));
        formData.append('smoking', values.smoking);
        formData.append('drinking_beer', values.drinking_beer);
        formData.append('hobbies', values.hobbies.join(','));
        formData.append('strengths', values.strengths.join(','));
        formData.append('weaknesses', values.weaknesses.join(','));
        formData.append('medical_history', values.medical_history);
        formData.append('spouse', values.spouse);
        formData.append('personal_income', values.personal_income);
        formData.append('family_income', values.family_income);
        formData.append('relatives_in_japan', values.relatives_in_japan);
        formData.append('japanese_address', values.japanese_address);
        formData.append('experience_coming_to_japan', values.experience_coming_to_japan);
        formData.append('desired_years_to_work_in_japan', values.desired_years_to_work_in_japan);
        formData.append('savings_per_year', values.savings_per_year);
        formData.append('plans_or_goals_after_returning', values.plans_or_goals_after_returning);
        formData.append('version', activeTab === "EN" ? "EN" : 'JP')
        formData.append('academic_details', JSON.stringify(values.academic_details));
        formData.append('family_details', JSON.stringify(values.family_details));
        formData.append('work_experience_list', JSON.stringify(values.work_experience_list));
        if (editData) {

            formData.append('id', values.id);
            formData.append('japanese_file', typeof values.japanese_file === 'string' && values.japanese_file.includes('http') ? '' : values.japanese_file);

            try {
                const response = await dispatch(udpateApplication({ id: editData.id, formData })).unwrap();

                if (response.status === 200) {
                    console.log("response updated data", response);
                    handleBack();
                    toast.success('Candidate Resume Updated Successfully');
                } else {
                    console.log("response error message data", response);
                    toast.error(response.payload?.data?.message || 'Failed to update resume');
                }
            } catch (e) {
                console.log("Unexpected error occurred in update resume:", e);
            } finally {
                setIsLoading(false);
            }



        } else {


            formData.append('japanese_file', role === 'kerala_intermediate' || role === 'admin' ? values.japanese_file : "")
            // const response = await dispatch(addResume(formData));
            await dispatch(addApplication(formData)).then((response) => {
                if (response.payload.status === 201) {
                    console.log("response posted data", response)
                    handleBack();
                    toast.success('Candidate Resume Added Successfully');
                } else {
                    console.log("response error message data", response)

                    toast.error(response.payload.data.message)
                }
            }).catch(e => {
                console.log("Unexpected error occurred in resume add:", e)
            }).finally(() => {
                setIsLoading(false);
            });

        }
    };
    const handleTabClick = (value) => {
        if (!editData?.id || value !== "JP") {
            setActiveTab(value);
            return;
        }
        // ! need to fetch the JP resume data if it exists
        setIsLoading(true);
        dispatch(getJapaneseApplicationById(editData.id))
            .then((response) => {
                if (response.type?.includes('fulfilled')) {
                    setActiveTab(value);
                }
            })
            .finally(() => setIsLoading(false));
    };

    const academicFields = [
        { fieldName: "id", fieldLabel: "", type: "", placeholder: "" },
        { fieldName: "start_year", fieldLabel: "Start Year", type: "date", placeholder: "Select start date" },
        { fieldName: "end_year", fieldLabel: "End Year", type: "date", placeholder: "Select end date" },
        { fieldName: "school_name", fieldLabel: "School Name", type: "text", placeholder: "Enter school name" },
        { fieldName: "license", fieldLabel: "License", type: "text", placeholder: "Enter license (e.g., BE)" },
        { fieldName: "expert", fieldLabel: "Expert", type: "text", placeholder: "Enter expert area" },
    ];

    const familyFields = [
        { fieldName: "id", fieldLabel: "", type: "", placeholder: "" },
        { fieldName: "name", fieldLabel: "Name", type: "text", placeholder: "Enter name" },
        { fieldName: "relationship", fieldLabel: "Relationship", type: "text", placeholder: "Enter relationship" },
        { fieldName: "age", fieldLabel: "Age", type: "number", placeholder: "Enter age" },
        { fieldName: "occupation", fieldLabel: "Occupation", type: "text", placeholder: "Enter occupation" },
    ];

    const workExperienceFields = [
        { fieldName: "id", fieldLabel: "", type: "", placeholder: "" },
        { fieldName: "start_year", fieldLabel: "Start Year", type: "date", placeholder: "Select start date" },
        { fieldName: "end_year", fieldLabel: "End Year", type: "date", placeholder: "Select end date" },
        { fieldName: "job_description", fieldLabel: "Job Description", type: "text", placeholder: "Enter job description" },
        { fieldName: "equipment_used", fieldLabel: "Equipment Used", type: "text", placeholder: "Enter equipment used" },
        { fieldName: "company_name", fieldLabel: "Company Name", type: "text", placeholder: "Enter company name" },
    ];
    const academicFieldsJp = [
        { fieldName: "id", fieldLabel: "", type: "", placeholder: "" },
        { fieldName: "start_year", fieldLabel: "開始年", type: "date", placeholder: "開始日を選択してください" },
        { fieldName: "end_year", fieldLabel: "終了年", type: "date", placeholder: "終了日を選択してください" },
        { fieldName: "school_name", fieldLabel: "学校名", type: "text", placeholder: "学校名を入力してください" },
        { fieldName: "license", fieldLabel: "資格", type: "text", placeholder: "資格を入力してください（例：BE）" },
        { fieldName: "expert", fieldLabel: "専門分野", type: "text", placeholder: "専門分野を入力してください" },
    ];
    const familyFieldsJp = [
        { fieldName: "id", fieldLabel: "", type: "", placeholder: "" },
        { fieldName: "name", fieldLabel: "氏名", type: "text", placeholder: "氏名を入力してください" },
        { fieldName: "relationship", fieldLabel: "関係", type: "text", placeholder: "関係を入力してください" },
        { fieldName: "age", fieldLabel: "年齢", type: "number", placeholder: "年齢を入力してください" },
        { fieldName: "occupation", fieldLabel: "職業", type: "text", placeholder: "職業を入力してください" },
    ];
    const workExperienceFieldsJp = [
        { fieldName: "id", fieldLabel: "", type: "", placeholder: "" },
        { fieldName: "start_year", fieldLabel: "開始年", type: "date", placeholder: "開始日を選択してください" },
        { fieldName: "end_year", fieldLabel: "終了年", type: "date", placeholder: "終了日を選択してください" },
        { fieldName: "job_description", fieldLabel: "仕事内容", type: "text", placeholder: "仕事内容を入力してください" },
        { fieldName: "equipment_used", fieldLabel: "使用機器", type: "text", placeholder: "使用した機器を入力してください" },
        { fieldName: "company_name", fieldLabel: "会社名", type: "text", placeholder: "会社名を入力してください" },
    ];

    const initialValues = {
        ...editData,
        id: editData?.id || '',
        employeer_name: editData?.employeer_name || '',
        name: editData?.name || '',
        email: editData?.email || '',
        phone: editData?.phone || '',
        skill: editData?.skill ? editData?.skill.split(',') : [],
        sex: editData?.sex || '',
        file: editData?.file_download || '',
        years_of_exp: editData?.years_of_exp || '',
        language: editData?.language || '',
        japanese_file: editData?.japanese_file_path || '',
        arrival_date: editData?.arrival_date || '',
        emergency_contact: editData?.emergency_contact || '',
        coe: editData?.coe || '',
        employement_contract: editData?.employement_contract || '',
        air_ticket: editData?.air_ticket || '',
        passport_copy: editData?.passport_copy || '',
        resident_copy: editData?.resident_copy || '',
        visa: editData?.visa || '',
        remarks: editData?.remarks || '',
        option_file: editData?.option_file || '',
        employeer_name: editData?.employeer_name || '',

        //new fields
        admission_number: editData?.admission_number || '',
        ad_fees: editData?.ad_fees || '',
        date_of_admission: editData?.date_of_admission || '',
        dob: editData?.dob ? new Date(editData?.dob) : null,
        passport_no: editData?.passport_no || '',
        height: editData?.height || '',
        weight: editData?.weight || '',
        marital_status: editData?.marital_status || '',
        nationality: editData?.nationality || '',
        religion: editData?.religion || '',
        communication: editData?.communication || '',
        reference: editData?.reference || '',
        educational_qualification: editData?.educational_qualification || '',
        additional_qualification: editData?.additional_qualification || '',
        english_knowledge: editData?.english_knowledge || '',
        profile_pic: editData?.profile_pic || '',
        sign: editData?.sign || '',
        educationalCertificate: editData?.educationalCertificate || '',
        medicalReport: editData?.medicalReport || '',
        vaccinationCertificate: editData?.vaccinationCertificate || '',

        age: editData?.age || '',
        place_of_birth: editData?.place_of_birth || '',
        reason_for_apply: editData?.reason_for_apply || '',
        cooperative_living: editData?.cooperative_living || '',
        favorite_subject: editData?.favorite_subject || '',
        licenses_and_qualifications: editData?.licenses_and_qualifications || '',
        tattoo: editData?.tattoo || '',
        blood_type: editData?.blood_type || '',
        right_vision: editData?.right_vision || '',
        left_vision: editData?.left_vision || '',
        color_blindness: editData?.color_blindness || '',
        blood_pressure: editData?.blood_pressure || '',
        dominant_hand: editData?.dominant_hand || '',
        foods_cannot_eat: typeof editData?.foods_cannot_eat === 'string'
            ? editData?.foods_cannot_eat.split(',').map(h => h.trim()).filter(Boolean)
            : Array.isArray(editData?.foods_cannot_eat)
                ? editData?.foods_cannot_eat.map(h => String(h).trim()).filter(Boolean)
                : [],
        smoking: editData?.smoking || '',
        drinking_beer: editData?.drinking_beer || '',
        hobbies: typeof editData?.hobbies === 'string'
            ? editData?.hobbies.split(',').map(h => h.trim()).filter(Boolean)
            : Array.isArray(editData?.hobbies)
                ? editData?.hobbies.map(h => String(h).trim()).filter(Boolean)
                : [],
        strengths: typeof editData?.strengths === 'string'
            ? editData?.strengths.split(',').map(h => h.trim()).filter(Boolean)
            : Array.isArray(editData?.strengths)
                ? editData?.strengths.map(h => String(h).trim()).filter(Boolean)
                : [],
        weaknesses: typeof editData?.weaknesses === 'string'
            ? editData?.weaknesses.split(',').map(h => h.trim()).filter(Boolean)
            : Array.isArray(editData?.weaknesses)
                ? editData?.weaknesses.map(h => String(h).trim()).filter(Boolean)
                : [],
        medical_history: editData?.medical_history || '',
        spouse: editData?.spouse || '',
        personal_income: editData?.personal_income || '',
        family_income: editData?.family_income || '',
        relatives_in_japan: editData?.relatives_in_japan || '',
        japanese_address: editData?.japanese_address || '',
        experience_coming_to_japan: editData?.experience_coming_to_japan ?? '',
        desired_years_to_work_in_japan: editData?.desired_years_to_work_in_japan ?? '',
        savings_per_year: editData?.savings_per_year || '',
        plans_or_goals_after_returning: editData?.plans_or_goals_after_returning || '',
        version: editData?.version || '',
        academic_details: editData?.academic_details || '',
        family_details: editData?.family_details || '',
        work_experience_list: editData?.work_experience_list || '',
        english_pdf: editData?.english_pdf || '',
        japanese_pdf: editData?.japanese_pdf || ''
    }

    const getFieldComponent = (component) => {
        switch (component?.fieldType) {
            case 'TEXT':
                return (
                    <div className="col-md-4 px-3 py-2" key={component?.name}>
                        <label className='form-label'>{component?.label}</label>
                        <Field
                            type='text'
                            className={`form-control ${component?.className}`}
                            placeholder={component?.placeholder}
                            name={component?.name}
                            disabled={component?.disabled}
                        />
                        <ErrorMessage name={component?.name} component='div' className="text-danger" />
                    </div>
                )
            case 'NUMBER':
                return (
                    <div className="col-md-4 px-3 py-2" key={component?.name}>
                        <label className='form-label'>{component?.label}</label>
                        <Field
                            type='number'
                            className={`form-control ${component?.className}`}
                            placeholder={component?.placeholder}
                            name={component?.name}
                            min={0}
                            disabled={component?.disabled}
                        />
                        <ErrorMessage name={component?.name} component='div' className="text-danger" />
                    </div>
                )
            case 'SELECT':
                return (
                    <div className="col-md-4 px-3 py-2" key={component?.name}>
                        <label className='form-label'>{component?.label}</label>
                        <Field as="select" className={`form-select ${component?.className}`} name={component?.name} disabled={component?.disabled} value={component?.values}>
                            <option value="" selected hidden label={component?.placeholder} />
                            {component?.options?.map((option, index) => (
                                <option key={index} value={option.value}>{option.label}</option>))}
                        </Field >
                        <ErrorMessage name={component?.name} component='div' className="text-danger" />

                    </div>
                )
            case 'FILE':
                return (
                    <div className="col-md-4 px-3 py-2" key={component?.name}>
                        <label className='form-label'>{component?.label}</label>
                        <input
                            type="file"
                            className={`form-control ${component?.className}`}
                            name={component?.name}
                            onChange={(event) => {
                                component?.setFieldValue(component?.name, event.target.files[0]);
                            }}
                            disabled={component?.disabled}
                        />
                        <ErrorMessage name={component?.name} component='div' className="text-danger" />

                        {component?.values && typeof component?.values === 'string' && (
                            <a href={component?.value} target="_blank" rel="noopener noreferrer" className={`d-block mt-2 ${component?.hidden ? "hidden" : ""}`}>
                                Download Current File
                            </a>
                        )}
                    </div>
                )
            case 'DATE':
                return (
                    <div className="col-md-4 px-3 py-2" key={component?.name}>
                        <label className='form-label'>{component?.label}</label>
                        <DatePicker className={`form-control ${component?.className}`} placeholderText={component?.placeholder}
                            peekNextMonth showMonthDropdown showYearDropdown dropdownMode='select'
                            dateFormat='dd/MM/yyyy'
                            disabled={component?.disabled}
                            selected={
                                dayjs(component?.values).isValid()
                                    ? component?.values
                                    : null
                            }

                            onChange={(date) => { 
                                component?.setFieldValue(component?.name, date)
                                if(component?.name === "dob"){
   const today = new Date();
                          const age =
                            today.getFullYear() -
                            date.getFullYear() -
                            (new Date(
                              today.getFullYear(),
                              date.getMonth(),
                              date.getDate(),
                            ) > today
                              ? 1
                              : 0);                                    if(typeof age === "number" && !isNaN(age)){
                                        component?.setFieldValue("age", age);
                                    }
                                }
                             }}
                        />
                        <ErrorMessage name={component?.name} component='div' className="text-danger" />
                    </div>
                )

            case 'MULTISELECT':
                return (<div className="col-md-4 px-3 py-2" key={component?.name}>
                    <label className='form-label'>{component?.label}</label>
                    <div className="chips-input-wrapper" style={{ position: 'relative' }}>
                        <div className="chips-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                            <input
                                type="text"
                                className={`form-control ${component?.className}`}
                                value={component?.newChipValue || ''}
                                onChange={(e) =>
                                    component?.setNewChip(prev => ({ ...prev, [component?.name]: e.target.value }))
                                }
                                onKeyDown={(e) => component?.handleKeyDown(e, component?.name)}
                                placeholder="Add a chip and press Enter"
                                disabled={component?.disabled}
                            />
                            <ErrorMessage name={component?.name} component='div' className="text-danger" />
                            {component?.values.map((chip, index) => (
                                <div key={index} className="chip" style={{ display: 'flex', alignItems: 'center', padding: '0 8px', backgroundColor: '#007bff', color: 'white', borderRadius: '16px' }}>
                                    {chip}
                                    <button
                                        type="button"
                                        className="btn-close btn-close-white ml-2"
                                        aria-label="Close"
                                        onClick={() => component?.handleRemoveChip(chip, component?.name)}
                                        disabled={component?.disabled}
                                    ></button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>)

            case "MODAL":
                return (
                    <div className="col-md-4 px-3 py-2" key={component?.name}>
                        <label className='form-label'>{component?.label}</label>
                        <div>
                            {
                                component?.values?.length > 0 ? (
                                    <>
                                        <button type="button" className="btn btn-warning me-2"
                                            onClick={() => component?.handleEditDetails(component?.values)}>
                                            {activeTab === "EN" ? " Update" : " 更新"} {component?.label}
                                        </button>
                                    </>
                                ) :
                                    <button type="button" className="btn btn-success"
                                        onClick={component?.handleAddDetails}>
                                        {activeTab === "EN" ? " Add" : " 追加"} {component?.label}
                                    </button>
                            }

                        </div>
                        {component?.isOpen && activeModal === component?.name && (
                            <MultiFieldModal className={`form-control ${component?.className}`} disabled={component?.disabled} handleCloseModal={component?.handleCloseModal} fields={component?.fields} containerFieldName={component?.containerFieldName} modalTitle={component?.modalTitle} setFieldValue={component?.setFieldValue} initialData={component?.initialModalData} />
                        )}

                    </div>
                )
            case 'FILE_PREVIEW':
                return (
                    <div className="col-md-4 px-3 py-2" key={component?.name}>
                        {component?.values && typeof component?.values === 'string' && <label className='form-label'>{component?.label}</label>}

                        {
                            component?.values && typeof component?.values === 'string' ? (
                                component?.values.includes('.pdf') ? (
                                    <embed src={component?.values} type='application/pdf' width='100%' />
                                ) : (
                                    <img src={component?.values} alt='candidatePdf' />
                                )
                            ) : null
                        }

                        {component?.values && typeof component?.values === 'string' && (
                            <a href={component?.values} target="_blank" rel="noopener noreferrer" >
                                Download Current File
                            </a>
                        )}
                    </div>
                )
            default:
                return null;
        }
    }

    const adminFields = [
        {
            label: "Name", name: "name", fieldType: "TEXT", placeholder: "Enter User Name",
            disabled: role === 'kerala_intermediate',
        },
        {
            label: "Phone Number", name: "phone", fieldType: "TEXT", placeholder: "Enter Phone Number",

        },
        {
            label: "Gender",
            name: "sex", fieldType: "SELECT", placeholder: "Select the Gender",
            disabled: role === 'kerala_intermediate',
            options: [{
                value: "Male", label: "Male"
            },
            {
                value: "Female", label: "Female"
            },
            {
                value: "Other", label: "Other"
            },

            ],
        },
        {
            label: "Japanese language level", name: "language",
            fieldType: "SELECT", placeholder: "Select the Japanese language level",
            disabled: role === 'kerala_intermediate',
            options: [
                {
                    value: "Beginner", label: "Beginner"
                },
                {
                    value: "N5", label: "N5"
                },
                {
                    value: "N4", label: "N4"
                },
                {
                    value: "N3", label: "N3"
                },
                {
                    value: "N2", label: "N2"
                },
                {
                    value: "N1", label: "N1"
                },
            ]
        },
        {
            label: "Resume",
            name: "file",
            disabled: role === 'kerala_intermediate',
            fieldType: "FILE",
        },
        {
            label: "Japanese Resume",
            name: "japanese_file",
            fieldType: "FILE",
            disabled: role === 'kerala_hr',
        },
        {
            label: "Company Name",
            name: "employeer_name",
            fieldType: "TEXT",
            placeholder: "Enter Company Name",
            disabled: role === 'kerala_intermediate',
        },
        {
            label: "DOB",
            name: "dob",
            fieldType: "DATE",
            placeholder: "Select Date of Birth",
            disabled: role === 'kerala_intermediate',
        },
        {
            label: "Religion",
            name: "religion",
            fieldType: "TEXT",
            disabled: role === 'kerala_intermediate',
            placeholder: "Enter Religion",

        },
        {
            label: "Height",
            name: "height",
            fieldType: "NUMBER",
            disabled: role === 'kerala_intermediate',
            placeholder: "Enter Height",
        },
        {
            label: "Weight",
            name: "weight",
            fieldType: "NUMBER",
            disabled: role === 'kerala_intermediate',
            placeholder: "Enter Weight",
        },
        {
            label: "Communication Address",
            name: "communication",
            fieldType: "TEXT",
            disabled: role === 'kerala_intermediate',
            placeholder: "Enter Communication Address",
        },
        {
            label: "Full size photo",
            name: "profile_pic",
            disabled: role === 'kerala_intermediate',
            fieldType: "FILE",
        },
        {
            label: "Signature",
            disabled: role === 'kerala_intermediate',
            name: "sign",
            fieldType: "FILE",
        },
        {
            label: "Educational Certificate",
            name: "educationalCertificate",
            disabled: role === 'kerala_intermediate',
            fieldType: "FILE",
        },
        {
            label: "Medical Report",
            name: "medicalReport",
            disabled: role === 'kerala_intermediate',
            fieldType: "FILE",
        },
        {
            label: "Vaccination Certificate",
            name: "vaccinationCertificate",
            fieldType: "FILE",
            disabled: role === 'kerala_intermediate',
        },
        {
            label: "Age",
            name: "age",
            fieldType: "NUMBER",
            // disabled: role === 'kerala_intermediate',
            disabled:true,
            placeholder: "Enter Age",
        },
        {
            label: "Birth Place",
            name: "place_of_birth",
            disabled: role === 'kerala_intermediate',
            fieldType: "TEXT",
            placeholder: "Enter Birth Place",
        },
        {
            label: "Reason For Apply",
            name: "reason_for_apply",
            disabled: role === 'kerala_intermediate',
            fieldType: "TEXT",
            placeholder: "Enter Reason For Apply",
        },
        {
            label: "Co-operative Living",
            disabled: role === 'kerala_intermediate',
            name: "cooperative_living",
            fieldType: "TEXT",
            placeholder: "Enter Co-operative Living",
        }, {
            label: "Favourite Subject",
            name: "favorite_subject",
            disabled: role === 'kerala_intermediate',
            fieldType: "TEXT",
            placeholder: "Enter Favourite Subject",
        },
        {
            label: "License & Qualification",
            disabled: role === 'kerala_intermediate',
            name: "licenses_and_qualifications",
            fieldType: "TEXT",
            placeholder: "Enter License & Qualification",
        },
        {
            label: "Tattoo",
            name: "tattoo",
            fieldType: "SELECT",
            placeholder: "Select Tattoo",
            disabled: role === 'kerala_intermediate',
            options: [{
                value: "Yes", label: "Yes"
            },
            {
                value: "No", label: "No"
            },
            ],

        },
        {
            label: "Blood Type",
            name: "blood_type",
            disabled: role === 'kerala_intermediate',
            fieldType: "TEXT",
            placeholder: "Enter Blood Type",

        },
        {
            label: "Right Vision",
            name: "right_vision",
            fieldType: "TEXT",
            disabled: role === 'kerala_intermediate',
            placeholder: "Enter Right Vision",
        },
        {
            label: "Left Vision",
            name: "left_vision",
            disabled: role === 'kerala_intermediate',
            fieldType: "TEXT",
            placeholder: "Enter Left Vision",
        }, {
            label: "Color Blindness",
            name: "color_blindness",
            disabled: role === 'kerala_intermediate',
            fieldType: "TEXT",
            placeholder: "Select Color Blindness",
        }, {
            label: "Blood Pressure",
            name: "blood_pressure",
            disabled: role === 'kerala_intermediate',
            fieldType: "TEXT",
            placeholder: "Enter Blood Pressure",
        }, {
            label: "Dominant Hand",
            disabled: role === 'kerala_intermediate',
            name: "dominant_hand",
            fieldType: "SELECT",
            placeholder: "Select Dominant Hand",
            options: [
                { value: "Right Hand", label: "Right Hand" },
                { value: "Left Hand", label: "Left Hand" },
            ],
        }, {
            label: "Foods Cannot Eat",
            name: "foods_cannot_eat",
            disabled: role === 'kerala_intermediate',
            fieldType: "MULTISELECT",
            placeholder: "Add Foods Cannot Eat",
            newChipValue: newChip?.foods_cannot_eat || '',
        },
        {
            label: "Smoking",
            disabled: role === 'kerala_intermediate',
            name: "smoking",
            fieldType: "SELECT",
            placeholder: "Select Smoking",
            options: [{
                value: "Yes", label: "Yes"
            },
            {
                value: "No", label: "No"
            },
            ],
        },
        {
            label: "Drinking Beer",
            disabled: role === 'kerala_intermediate',
            name: "drinking_beer",
            fieldType: "SELECT",
            placeholder: "Select Drinking Beer",
            options: [{
                value: "Yes", label: "Yes"
            },
            {
                value: "No", label: "No"
            },
            ],
        },
        {
            label: "Hobbies",
            name: "hobbies",
            disabled: role === 'kerala_intermediate',
            fieldType: "MULTISELECT",
            placeholder: "Add Hobbies",
            newChipValue: newChip?.hobbies || '',
        },
        {
            label: "Strengths",
            name: "strengths",
            disabled: role === 'kerala_intermediate',
            fieldType: "MULTISELECT",
            placeholder: "Add Strengths",
            newChipValue: newChip?.strengths || '',
        },
        {
            label: "Weaknesses",
            name: "weaknesses",
            fieldType: "MULTISELECT",
            disabled: role === 'kerala_intermediate',
            placeholder: "Add Weaknesses",
            newChipValue: newChip?.weaknesses || '',
        },
        {
            label: "Medical History",
            disabled: role === 'kerala_intermediate',
            name: "medical_history",
            fieldType: "TEXT",
            placeholder: "Enter Medical History",

        },
        {
            label: "Spouse",
            name: "spouse",
            fieldType: "SELECT",
            disabled: role === 'kerala_intermediate',
            placeholder: "Select Spouse Name",
            options: [
                { value: "Yes", label: "Yes" },
                { value: "No", label: "No" },
            ],

        },
        {
            label: "Personal Income (Yen)",
            name: "personal_income",
            fieldType: "NUMBER",
            disabled: role === 'kerala_intermediate',
            placeholder: "Enter Personal Income ",

        },
        {
            label: "Family Income (Yen)",
            name: "family_income",
            disabled: role === 'kerala_intermediate',
            fieldType: "NUMBER",
            placeholder: "Enter Family Income",

        },
        {
            label: "Relatives in Japan",
            disabled: role === 'kerala_intermediate',
            name: "relatives_in_japan",
            fieldType: "SELECT",
            placeholder: "Select Relatives in Japan",
            options: [{
                value: "Yes", label: "Yes"
            },
            {
                value: "No", label: "No"
            },
            ],

        },
        {
            label: "Japanese Address",
            disabled: role === 'kerala_intermediate',
            name: "japanese_address",
            fieldType: "TEXT",
            placeholder: "Enter Japanese Address",

        },
        {
            label: "Your Experience Visiting Japan",
            name: "experience_coming_to_japan",
            disabled: role === 'kerala_intermediate',
            fieldType: "NUMBER",
            placeholder: "Enter  Experience Visiting Japan",

        },
        {
            label: 'Desired Years to Work in Japan',
            disabled: role === 'kerala_intermediate',
            name: 'desired_years_to_work_in_japan',
            fieldType: 'NUMBER',
            placeholder: 'Enter Desired Years to Work in Japan',
        },
        {
            label: "Savings per Year (Yen)",
            name: "savings_per_year",
            disabled: role === 'kerala_intermediate',
            fieldType: "NUMBER",
            placeholder: "Enter Savings per Year",
        },
        {
            label: "Goals After Returning",
            disabled: role === 'kerala_intermediate',
            name: "plans_or_goals_after_returning",
            fieldType: "TEXT",
            placeholder: "Enter Plans or Goals After Returning",
        },
        {
            label: "Academic Details",
            name: "academic_details",
            disabled: role === 'kerala_intermediate',
            fieldType: "MODAL",
            handleAddDetails: () => {
                setIsModalOpen(true);
                setActiveModal('academic_details')
                setInitialModalData([]);
            },
            handleEditDetails: (values) => {
                setIsModalOpen(true);
                setActiveModal('academic_details')
                setInitialModalData(values || []);
            },
            handleCloseModal: () => setIsModalOpen(false),
            fields: academicFields,
            containerFieldName: "academic_details",
            modalTitle: "Academic Details",
            isOpen: isOpen,
            initialModalData: initialModalData,
        },
        {
            label: "Family Details",
            name: "family_details",
            fieldType: "MODAL",
            disabled: role === 'kerala_intermediate',
            handleAddDetails: () => {
                setIsModalOpen(true);
                setActiveModal('family_details');
                setInitialModalData([]);
            },
            handleEditDetails: (values) => {
                setIsModalOpen(true);
                setActiveModal('family_details');
                setInitialModalData(values || []);
            },
            handleCloseModal: () => setIsModalOpen(false),
            fields: familyFields,
            containerFieldName: "family_details",
            modalTitle: "Family Details",
            isOpen: isOpen,
            initialModalData: initialModalData,
        },
        {
            label: "Work Experience List",
            name: "work_experience_list",
            disabled: role === 'kerala_intermediate',
            fieldType: "MODAL",
            handleAddDetails: () => {
                setIsModalOpen(true);
                setActiveModal('work_experience_list');
                setInitialModalData([]);
            }, handleEditDetails: (values) => {
                setIsModalOpen(true);
                setActiveModal('work_experience_list');
                setInitialModalData(values || []);
            },
            handleCloseModal: () => setIsModalOpen(false),
            fields: workExperienceFields,
            containerFieldName: "work_experience_list",
            modalTitle: "Work Experience List",
            isOpen: isOpen,
            initialModalData: initialModalData,
        },
        {
            label: "Japanese PDF",
            disabled: role === 'kerala_intermediate',
            name: "japanese_pdf",
            fieldType: "FILE_PREVIEW"
        }

    ]
    const adminJpFields = [
        { label: "名前", name: "name", fieldType: "TEXT", placeholder: "ユーザー名を入力してください", },
        {
            label: "フリガナ", name: "japanese_language", fieldType: "TEXT", placeholder: "フリガナ",
            disabled: !["kerala_intermediate", "admin"].includes(role)
        },
        {
            label: "性別",
            name: "sex", fieldType: "SELECT", placeholder: "性別を選択してください",
            options: [
                { value: "Male", label: "男性" },
                { value: "Female", label: "女性" },
                { value: "Other", label: "その他" },

            ],
        },
        {
            label: "日本語レベル", name: "language",
            fieldType: "SELECT", placeholder: "日本語レベルを選択してください",
            options: [
                { value: "Beginner", label: "初級" },
                { value: "N5", label: "N5" },
                { value: "N4", label: "N4" },
                { value: "N3", label: "N3" },
                { value: "N2", label: "N2" },
                { value: "N1", label: "N1" },
            ]
        },
        {
            label: "会社名",
            name: "employeer_name",
            fieldType: "TEXT",
            placeholder: "会社名を入力してください",
        },
        {
            label: "生年月日",
            name: "dob",
            fieldType: "DATE",
            disabled: role === 'kerala_intermediate',

            placeholder: "生年月日を選択してください",
        },
        {
            label: "宗教",
            name: "religion",
            fieldType: "TEXT",
            placeholder: "宗教を入力してください",
        },
        {
            label: "身長",
            name: "height",
            disabled: role === 'kerala_intermediate',
            fieldType: "NUMBER",
            placeholder: "身長を入力してください",
        },
        {
            label: "体重",
            disabled: role === 'kerala_intermediate',
            name: "weight",
            fieldType: "NUMBER",
            placeholder: "体重を入力してください",
        },
        {
            label: "現住所",
            name: "communication",
            fieldType: "TEXT",
            placeholder: "現住所を入力してください",
        },
        {
            label: "年齢",
            name: "age",
            fieldType: "NUMBER",
            disabled: role === 'kerala_intermediate',
            placeholder: "年齢を入力してください",
        },
        {
            label: "出生地",
            name: "place_of_birth",
            fieldType: "TEXT",
            placeholder: "出生地を入力してください",
        },
        {
            label: "志望動機",
            name: "reason_for_apply",
            fieldType: "TEXT",
            placeholder: "志望動機を入力してください",
        },
        {
            label: "共同生活経験",
            name: "cooperative_living",
            fieldType: "TEXT",
            placeholder: "共同生活について入力してください",
        },
        {
            label: "好きな科目",
            name: "favorite_subject",
            fieldType: "TEXT",
            placeholder: "好きな科目を入力してください",
        },
        {
            label: "免許・資格",
            name: "licenses_and_qualifications",
            fieldType: "TEXT",
            placeholder: "免許・資格を入力してください",
        },
        {
            label: "タトゥー",
            name: "tattoo",
            fieldType: "SELECT",
            disabled: role === 'kerala_intermediate',
            placeholder: "タトゥーの有無を選択してください",
            options: [
                { value: "Yes", label: "有" },
                { value: "No", label: "無" },
            ],
        },
        {
            label: "血液型",
            name: "blood_type",
            disabled: role === 'kerala_intermediate',
            fieldType: "TEXT",
            placeholder: "血液型を入力してください",
        },
        {
            label: "右目視力",
            name: "right_vision",
            disabled: role === 'kerala_intermediate',
            fieldType: "TEXT",
            placeholder: "右目視力を入力してください",
        },
        {
            label: "左目視力",
            disabled: role === 'kerala_intermediate',
            name: "left_vision",
            fieldType: "TEXT",
            placeholder: "左目視力を入力してください",
        },
        {
            label: "色覚異常",
            name: "color_blindness",
            fieldType: "TEXT",
            placeholder: "色覚異常の有無を選択してください",
        },
        {
            label: "血圧",
            name: "blood_pressure",
            fieldType: "TEXT",
            placeholder: "血圧を入力してください",
        },
        {
            label: "利き手",
            name: "dominant_hand",
            fieldType: "SELECT",
            disabled: true,
            placeholder: "利き手を選択してください",
            options: [
                { value: "Right Hand", label: "右手" },
                { value: "Left Hand", label: "左手" },
            ],

        },
        {
            label: "食べられない食べ物",
            name: "foods_cannot_eat",
            fieldType: "MULTISELECT",
            placeholder: "食べられない食べ物を追加",
            newChipValue: newChip?.foods_cannot_eat || '',
        },
        {
            label: "喫煙",
            name: "smoking",
            disabled: role === 'kerala_intermediate',
            fieldType: "SELECT",
            placeholder: "喫煙の有無を選択してください",
            options: [
                { value: "Yes", label: "有" },
                { value: "No", label: "無" },
            ],
        },
        {
            label: "ビールを飲む",
            name: "drinking_beer",
            disabled: role === 'kerala_intermediate',
            fieldType: "SELECT",
            placeholder: "ビールを飲むかどうかを選択してください",
            options: [
                { value: "Yes", label: "有" },
                { value: "No", label: "無" },
            ],
        },
        {
            label: "趣味",
            name: "hobbies",
            fieldType: "MULTISELECT",
            placeholder: "趣味を追加",
            newChipValue: newChip?.hobbies || '',
        },
        {
            label: "長所",
            name: "strengths",
            fieldType: "MULTISELECT",
            placeholder: "長所を追加",
            newChipValue: newChip?.strengths || '',
        },
        {
            label: "短所",
            name: "weaknesses",
            fieldType: "MULTISELECT",
            placeholder: "短所を追加",
            newChipValue: newChip?.weaknesses || '',
        },
        {
            label: "病歴",
            name: "medical_history",
            fieldType: "TEXT",
            placeholder: "病歴を入力してください",
        },
        {
            label: "配偶者",
            name: "spouse",
            fieldType: "SELECT",
            disabled: role === 'kerala_intermediate',
            placeholder: "配偶者の名前を入力してください",
            options: [
                { value: "Yes", label: "有" },
                { value: "No", label: "無" },
            ],
        },
        {
            label: "本人収入 (円)",
            name: "personal_income",
            disabled: role === 'kerala_intermediate',
            fieldType: "NUMBER",
            placeholder: "本人収入を入力してください",
        },
        {
            label: "家族収入 (円)",
            name: "family_income",
            fieldType: "NUMBER",
            disabled: role === 'kerala_intermediate',
            placeholder: "家族収入を入力してください",
        },
        {
            label: "日本にいる親戚",
            name: "relatives_in_japan",
            fieldType: "SELECT",
            disabled: role === 'kerala_intermediate',
            placeholder: "日本にいる親戚を入力してください",
            options: [
                { value: "Yes", label: "有" },
                { value: "No", label: "無" },
            ],
        },
        {
            label: "日本での住所",
            name: "japanese_address",
            fieldType: "TEXT",
            placeholder: "日本での住所を入力してください",
        },
        {
            label: "日本訪問経験",
            name: "experience_coming_to_japan",
            disabled: role === 'kerala_intermediate',
            fieldType: "NUMBER",
            placeholder: "日本訪問経験を入力してください",
        },
        {
            label: '日本で働きたい年数',
            name: 'desired_years_to_work_in_japan',
            disabled: role === 'kerala_intermediate',
            fieldType: 'NUMBER',
            placeholder: '日本で働きたい年数を入力してください',
        },
        {
            label: "年間貯金額 (円)",
            name: "savings_per_year",
            disabled: role === 'kerala_intermediate',
            fieldType: "NUMBER",
            placeholder: "年間貯金額を入力してください",
        },
        {
            label: "帰国後の目標",
            name: "plans_or_goals_after_returning",
            fieldType: "TEXT",
            placeholder: "帰国後の目標を入力してください",
        },
        {
            label: "学歴詳細",
            name: "academic_details",
            fieldType: "MODAL",
            handleAddDetails: () => {
                setIsModalOpen(true);
                setActiveModal('academic_details')
                setInitialModalData([]);
            },
            handleEditDetails: (values) => {
                setIsModalOpen(true);
                setActiveModal('academic_details')
                setInitialModalData(values || []);
            },
            handleCloseModal: () => {
                setIsModalOpen(false)
                setInitialModalData([]);
            },
            fields: academicFieldsJp,
            containerFieldName: "academic_details",
            modalTitle: "学歴詳細",
            isOpen: isOpen,
            initialModalData: initialModalData,
        },
        {
            label: "家族情報",
            name: "family_details",
            fieldType: "MODAL",
            handleAddDetails: () => {
                setIsModalOpen(true);
                setActiveModal('family_details');
                setInitialModalData([]);
            },
            handleEditDetails: (values) => {
                setIsModalOpen(true);
                setActiveModal('family_details');
                setInitialModalData(values || []);
            },
            handleCloseModal: () => {
                setIsModalOpen(false)
                setInitialModalData([]);
            },
            fields: familyFieldsJp,
            containerFieldName: "family_details",
            modalTitle: "家族情報",
            isOpen: isOpen,
            initialModalData: initialModalData,
        },
        {
            label: "職歴一覧",
            name: "work_experience_list",
            fieldType: "MODAL",
            handleAddDetails: () => {
                setIsModalOpen(true);
                setActiveModal('work_experience_list');
                setInitialModalData([]);
            },
            handleEditDetails: (values) => {
                setIsModalOpen(true);
                setActiveModal('work_experience_list');
                setInitialModalData(values || []);
            },
            handleCloseModal: () => {
                setIsModalOpen(false)
                setInitialModalData([]);
            },
            fields: workExperienceFieldsJp,
            containerFieldName: "work_experience_list",
            modalTitle: "職歴一覧",
            isOpen: isOpen,
            initialModalData: initialModalData,
        }, {
            label: "PDF（日本語）",
            name: "japanese_pdf",
            fieldType: "FILE_PREVIEW"
        }
    ];

    const fieldsByRoleEn = {
        admin: adminFields,
        kerala_hr: adminFields,
        kerala_intermediate: adminFields
    }
    const fieldsByRoleJp = {
        admin: adminJpFields,
        kerala_hr: adminJpFields,
        kerala_intermediate: adminJpFields
    }
    const fieldsByTab = {
        EN: fieldsByRoleEn[role] || [],
        JP: fieldsByRoleJp[role] || []
    }


    return (
        <>
            {isLoading && <LoadingSpinner />}
            <div className="col-md-12">
                <div className="card p-3">
                    <ul className="nav nav-pills" id="pills-tab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button className={`nav-link custom-link ${activeTab === "EN" ? "active" : ""}`} id="pills-english-tab" data-bs-toggle="pill" data-bs-target="#pills-english" type="button" role="tab" aria-controls="pills-english" aria-selected="true" onClick={() => handleTabClick("EN")}>English</button>
                        </li>
                        {role == "kerala_hr" ? null :
                            <li className="nav-item" role="presentation" hidden={!editData?.id}>
                                <button className={`nav-link custom-link  ${activeTab === "JP" ? "active" : ""}`} id="pills-japanese-tab" data-bs-toggle="pill" data-bs-target="#pills-japanese" type="button" role="tab" aria-controls="pills-japanese" aria-selected="false" onClick={() => handleTabClick("JP")} >Japanese</button>
                            </li>
                        }
                    </ul>
                    <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        validationSchema={activeTab === "EN" ? validationSchema : validationSchemaJp}
                        onSubmit={handleSubmit}
                    >
                        {({ values, setFieldValue, errors }) => {
                            const handleAddChip = (fieldName) => {
                                const inputValue = newChip[fieldName];
                                if (inputValue && !values[fieldName].includes(inputValue)) {
                                    const updatedValues = [...values[fieldName], inputValue];
                                    setFieldValue(fieldName, updatedValues);
                                    setNewChip(prev => ({ ...prev, [fieldName]: '' }));
                                }
                            };
                            const handleRemoveChip = (chipToRemove, fieldName) => {
                                const updatedValues = values[fieldName].filter(chip => chip !== chipToRemove);
                                setFieldValue(fieldName, updatedValues);
                            };
                            const handleKeyDown = (e, fieldName) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    handleAddChip(fieldName);
                                }
                            };
                            return (<Form>
                                <div className="row">
                                    {
                                        fieldsByTab[activeTab].map((component, index) => {
                                            const options = component?.options || [];
                                            const disabled = component?.disabled || false;
                                            return (
                                                <React.Fragment key={index}>
                                                    {getFieldComponent({
                                                        ...component,
                                                        className: activeTab === "JP" ? "japanese-style" : "",
                                                        options,
                                                        disabled,
                                                        setFieldValue,
                                                        handleAddChip,
                                                        setNewChip: setNewChip,
                                                        handleRemoveChip,
                                                        handleKeyDown,
                                                        newChip: values[component.name] || '',
                                                        values: values[component.name] || [],
                                                        initialData: initialModalData,
                                                    })}
                                                </React.Fragment>
                                            )
                                        })
                                    }
                                </div>
                                <div className="row mt-3">
                                    <div className="col ">
                                        <button className='cancel-button ms-2' onClick={handleBack} type='button'>{
                                            activeTab === "EN" ? "Cancel" : "キャンセル"

                                        }</button>
                                        <button className="btn defult-button ms-2" type='submit'>
                                            {activeTab === "EN" ? "Submit" : "提出"}
                                        </button>
                                    </div>
                                </div>
                            </Form>
                            )
                        }}
                    </Formik>
                </div>
            </div>
        </>
    )
}
